export enum FeatureName {
  MAINTENANCE = 'maintenance',
  CAMPAIGN = 'campaign',
  SDK7_TEMPLATES = 'sdk7-templates',
  CREATE_SCENE_ONLY_SDK7 = 'create-scene-only-sdk7',
  ENS_ADDRESS = 'ens-address',
  PUBLISH_COLLECTIONS_WERT = 'publish-collections-wert',
  EXOTIC_RARITY = 'exotic-rarity',
  VRM_OPTOUT = 'vrm-optout'
}
